import React from 'react';
import AboutSection from '../components/sections/AboutSection';

const AboutPage = () => {
  return (
    <div className="pt-20">
      <AboutSection />
    </div>
  );
};

export default AboutPage;